import { render, staticRenderFns } from "./ModalRelative.vue?vue&type=template&id=359a6af9&"
import script from "./ModalRelative.vue?vue&type=script&lang=js&"
export * from "./ModalRelative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports